var render = function render(_c,_vm){return (_vm.props.to)?_c('router-link',{staticClass:"btn-icon",attrs:{"to":_vm.props.to},on:{"click":function($event){_vm.listeners.click && _vm.listeners.click()}}},[_c('i',{staticClass:"badge-circle",class:[_vm.data.staticClass, _vm.data.class, {
        'bx bx-trash badge-circle-danger': _vm.props.type === 'delete',
        'bx badge-circle-light-secondary bx-edit-alt': _vm.props.type === 'edit',
        'loading': _vm.props.loading
    }]})]):_c('a',{staticClass:"btn-icon",attrs:{"href":"#"},on:{"click":function($event){_vm.listeners.click && _vm.listeners.click()}}},[_c('i',{staticClass:"badge-circle",class:[_vm.data.staticClass, _vm.data.class, {
        'bx bx-trash badge-circle-danger': _vm.props.type === 'delete',
        'bx badge-circle-light-secondary bx-edit-alt': _vm.props.type === 'edit',
        'loading': _vm.props.loading
    }]})])
}
var staticRenderFns = []

export { render, staticRenderFns }